import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button";
import { useMutation } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import _Input from "../../../generic/_Input";
import _Select from "../../../generic/_Select";
import { errorLabels } from "../../../../utils/helpers";
import { ErrorMessage, SuccessMessage } from "../../../../utils/toastify";
const _ModalAddPricesRCS = (props) => {
  const {
    visible = false,
    onClose,
    title = "",
    data = {
      idCustomer: "",
      uidCustomer: "",
      arrayRCSTypes: {},
    },
    refetchRCSPrices,
  } = props;

  const auth = useAuth();
  const { token } = auth.getSessionData();

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    validateForm,
    submitForm,
    resetForm,
  } = useFormik({
    initialValues: {
      idcustomer: data?.uidCustomer,
      unitprice: 0,
      min: 0,
      max: 0,
      rcstype: "",
    },
    validationSchema: Yup.object({
      min: Yup.number(),
      max: Yup.number()
        .min(1, "El rango máximo debe ser mayor a 0")
        .required("El rango máximo es requerido"),
      unitprice: Yup.number()
        .min(0, "El precio unitario debe ser mayor a 0")
        .required("El precio unitario es requerido"),
      rcstype: Yup.string().required("El tipo de RCS es requerido"),
    }),
    onSubmit: async (values) => {
      await createPrice(values);
    },
  });

  const { mutate: createPrice } = useMutation({
    mutationFn: async (values) => {
      const res = await httpClient(
        "POST",
        `${ApiEndpoint}configuration/savercspricebycustomer`,
        values,
        token,
      );
      return res.data;
    },
    onSuccess: (data) => {
      if (data?.error) {
        ErrorMessage("Ha sucedido un error, por favor intente nuevamente");
      } else {
        SuccessMessage("Se ha creado el precio del cliente");
        refetchRCSPrices();
        _onClose();
      }
    },
  });
  const _onClose = () => {
    if (onClose) {
      onClose();
      resetForm();
    }
  };

  const onValidate = async () => {
    try {
      const isValid = await validateForm();

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errorLabels(isValid)}`);
      }
      await submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  return (
    <Modal show={visible} onHide={_onClose} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="grid grid-cols-1 gap-2 w-full">
          <_Input
            title="Rango mínimo"
            id="min"
            type="number"
            value={values.min}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.min && errors.min}
            errors={touched.min && errors.min ? errors.min : ""}
            autoComplete={"off"}
            required
          />
          <_Input
            title="Rango máximo"
            id="max"
            type="number"
            value={values.max}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.max && errors.max}
            errors={touched.max && errors.max ? errors.max : ""}
            autoComplete={"off"}
            required
          />
          <_Input
            title="Costo unitario"
            id="unitprice"
            type="number"
            value={values.unitprice}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.unitprice && errors.unitprice}
            errors={
              touched.unitprice && errors.unitprice ? errors.unitprice : ""
            }
            autoComplete={"off"}
            required
          />

          <_Select
            title="Tipo de RCS"
            id="rcstype"
            value={values.rcstype}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.rcstype && errors.rcstype}
            errors={touched.rcstype && errors.rcstype ? errors.rcstype : ""}
            options={[
              {
                label: "Seleccione un tipo de RCS",
                value: 0,
              },
              ...Object.entries(data?.arrayRCSTypes).map(([key, value]) => ({
                label: value,
                value: key,
              })),
            ]}
            required
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <_Button title="Cerrar" style="outline" onClick={_onClose} />
        <_Button title="Guardar" style="primary" onClick={onValidate} />
      </Modal.Footer>
    </Modal>
  );
};

_ModalAddPricesRCS.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
  refetchRCSPrices: PropTypes.func,
};

export default _ModalAddPricesRCS;
